import './style.less';

export default function($log) {
  'ngInject';
}



// WEBPACK FOOTER //
// ./src/app/controllers/admin/settings/nav/index.js